module.exports = __webpack_public_path__ + "media/assets/numeric_field-00203bdd79e58d183c64b54f2c2e2c74.svg";